import { cn } from "@/lib/utils";

type BadgeVariant =
  | "default"
  | "primary"
  | "secondary"
  | "success"
  | "error"
  | "warning"
  | "info"
  | "outline";

interface BadgeProps {
  children: React.ReactNode;
  variant?: BadgeVariant;
  className?: string;
}

const variantClasses: Record<BadgeVariant, string> = {
  default:
    "bg-muted text-foreground-secondary",
  primary:
    "bg-primary/10 text-primary dark:bg-primary/20",
  secondary:
    "bg-secondary/10 text-secondary dark:bg-secondary/20 dark:text-amber-400",
  success:
    "bg-success-light text-success-dark dark:bg-success/20 dark:text-success",
  error:
    "bg-error-light text-error-dark dark:bg-error/20 dark:text-error",
  warning:
    "bg-warning-light text-warning-dark dark:bg-warning/20 dark:text-warning",
  info:
    "bg-info-light text-info-dark dark:bg-info/20 dark:text-info",
  outline:
    "border border-border text-foreground-secondary bg-transparent",
};

export function Badge({
  children,
  variant = "default",
  className,
}: BadgeProps) {
  return (
    <span
      className={cn(
        "inline-flex items-center rounded-pill px-2.5 py-0.5 text-xs font-medium transition-colors duration-base",
        variantClasses[variant],
        className
      )}
    >
      {children}
    </span>
  );
}
